import InsureProcessMoto from './InsureProcessMoto';
export default InsureProcessMoto;
